import { CurrencyEnum, LocaleEnum, Popover, centsToUnits, units } from '@systemeio/ui'
import { AffiliateSumType } from 'modules/affiliate-program/affiliate/types/affiliate-interface'
import React from 'react'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { currencyFormat } from 'shared/utils/currency-format'

export const getAffiliateSum = (
  amountObj: AffiliateSumType,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
) =>
  selectedCurrency
    ? currencyFormat(centsToUnits(amountObj[selectedCurrency]), selectedCurrency, locale)
    : currencyFormat(units(0), CurrencyEnum.EURO, locale)

export const getAffiliateTotalSum = (
  amountObj: AffiliateSumType,
  t: TLocoType,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
) => (
  <div className={'flex gap-1.5 items-center'}>
    {getAffiliateSum(amountObj, selectedCurrency, locale)}
    {Object.keys(amountObj).length > 1 && (
      <Popover
        label={
          <div className={'flex flex-col gap-1 font-bold text-darkblue'}>
            {(Object.keys(amountObj) as CurrencyEnum[])
              .filter(cur => cur !== selectedCurrency)
              .map(cur => (
                <span key={cur}>{getAffiliateSum(amountObj, cur, locale)}</span>
              ))}
          </div>
        }
        popoverClassName={'max-w-[200px] sm:max-w-[350px]'}
      >
        {show => (
          <span
            className={`${
              show ? 'bg-blue' : 'bg-gray-100'
            } outline-none group-focus-visible:fill-blue text-white rounded-lg px-1`}
          >
            {t('global.more').toLowerCase()}
          </span>
        )}
      </Popover>
    )}
  </div>
)
